<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OujAoF/tc-custom/9781453232514.jpg?1733088073564" alt="This image is the cover for the book Wireless, Quinsigamond"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wireless, Quinsigamond
      </h1>
      <p class="bookDescription body article font2">
        <b>A homicide detective tries to stop an ex–FBI agent’s murderous rampage</b><br/>Though they posture themselves as revolutionary, the jammers are harmless. Radio nerds who gather each night at a nightclub called Wireless, they get their kicks by jamming commercial radio signals, hijacking their frequencies to broadcast anarchist messages to the ordinary citizens of Quinsigamond. But even though they do no harm, their hobby has attracted murderous attention. Speer’s killing spree starts with a priest. The one-time seminary student and ex–FBI agent has tired of seeing the city’s cathedral denigrated by immigrants, addicts, and gang members, and he blames Father Todorov for catering to the undesirables. He corners the priest in the confessional and takes out his rage with a Bowie knife. Now he wants the blood of the fiery young anarchists who hijack his radio dial each evening. Homicide detective Hannah Shaw must infiltrate this strange subculture before it is dismantled by Speer’s blade. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack O'Connell
      </h2>
      
      <p class="authorDescription body article">Jack O&rsquo;Connell (b. 1959) is the author of five critically acclaimed, <i>New York Times</i> bestselling crime novels. Born in Worcester, Massachusetts, O&rsquo;Connell&rsquo;s  earliest reading was the dime novel paperbacks and pulp fiction sold in  his corner drug store, whose hard-boiled attitude he carried over to  his own writing. He has cited his hometown&rsquo;s bleak, crumbling  infrastructure as an influence on Quinsigamond, the fictional city where  his first four novels were set, and whose decaying industrial landscape  served as a backdrop for strange thrillers which earned O&rsquo;Connell the  nickname of a &ldquo;cyberpunk Dashiell Hammett.&rdquo;<BR>O&rsquo;Connell&rsquo;s most recent novel was <i>The Resurrectionist</i> (2008). A former student at Worcester&rsquo;s College of the Holy Cross, he  now teaches there, not far from where he and his family live just  outside of his hometown.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f32cebf